import React from "react";

import shrj from "../assets/images/medical_logo/shrj.jpg";
import shxh from "../assets/images/medical_logo/shxhyy.jpg";
import shfdek from "../assets/images/medical_logo/fddxyy.jpg";
import tjyk from "../assets/images/medical_logo/tjykdxzyy.jpg";
import njet from "../assets/images/medical_logo/njetyy.jpg";
import szdxfy from "../assets/images/medical_logo/sdfyy.jpg";
const Footer = () => {
  function scrollTop() {
    window.scrollTo(0, 0);
  }
  return (
    <div>
      <footer className="site-footer">
        <div className="site-footer__upper">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-6 col-sm-12">
                <div className="footer-widget footer-widget__contact">
                  <h2 className="footer-widget__title">产品中心</h2>
                  <ul className="list-unstyled footer-widget__course-list">
                    <li>  
                      <h2>                   
                        <a href="#none">智能分拣设备</a> <br/><br/>
                        <a href="#none">智能贴签设备</a><br/><br/>
                        <a href="#none">智能摆药设备</a>      
                      </h2>          
                    </li>      
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-sm-12">
                <div className="footer-widget footer-widget__link">
                  <h2 className="footer-widget__title">敬请期待</h2>
                  <div className="footer-widget__link-wrap">
                    <ul className="list-unstyled footer-widget__link-list">
                      <li>
                        <a href="#none">智能加药机器人</a>
                      </li>
                      <li>
                        <a href="#none">智能盘点设备</a>
                      </li>
                      <li>
                        <a href="#none">智能剥药设备</a>
                      </li>
                      {/* <li>
                        <a href="#none"></a>
                      </li>
                      <li>
                        <a href="#none"></a>
                      </li> */}
                    </ul>
                    <ul className="list-unstyled footer-widget__link-list">
                      {/* <li>
                        <a href="#none"> </a>
                      </li>
                      <li>
                        <a href="#none"></a>
                      </li>
                      <li>
                        <a href="#none"></a>
                      </li> */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-sm-12">
                <div className="footer-widget footer-widget__gallery">
                  <h2 className="footer-widget__title">合作伙伴</h2>
                  <ul className="list-unstyled footer-widget__gallery-list">
                    <li>
                      <a href="#none">
                        <img src={shrj} alt="" />
                      </a>
                    </li>
                    <li>
                      <a href="#none">
                        <img src={shxh} alt="" />
                      </a>
                    </li>
                    <li>
                      <a href="#none">
                        <img src={shfdek} alt="" />
                      </a>
                    </li>
                    <li>
                      <a href="#none">
                        <img src={tjyk} alt="" />
                      </a>
                    </li>
                    <li>
                      <a href="#none">
                        <img src={szdxfy} alt="" />
                      </a>
                    </li>
                    <li>
                      <a href="#none">
                        <img src={njet} alt="" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-xl-3 col-lg-6 col-sm-12">
                <div className="footer-widget footer-widget__about">
                  <h2 className="footer-widget__title">关于</h2>
                  <p className="footer-widget__text">
                    联系我们的专家,<br/>
                    苏州卫捷将竭尽为您提供PIVAS全流程解决方案<br/>
                    <br/>
                    联系电话 : <span style={{color:"#f16101"}}>  400-8388183 </span>
                   
                  </p>
                  <div className="footer-widget__btn-block">
                    <a href="/contact" className="thm-btn">
                      联系我们
                    </a>
                    {/* <a href="#none" className="thm-btn">
                      Purchase
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="site-footer__bottom">
          <div className="container">
            <p className="site-footer__copy">
              &copy; Copyright 2020 by <a href="#none">苏州卫捷医药科技有限公司</a> 版权所有，本公司保留所有权利             
            </p>
            
            <a className="site-footer__copy" href='http://beian.miit.gov.cn'>ICP备案证书号：苏ICP备13052500号</a>
          
            <div className="site-footer__social">
              <div
                onClick={scrollTop}
                onKeyDown={scrollTop}
                role="button"
                tabIndex={0}
                className="scroll-to-target site-footer__scroll-top"
              >
                <i className="kipso-icon-top-arrow"></i>
              </div>

              {/* <a href="#none">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#none">
                <i className="fab fa-facebook-square"></i>
              </a>
              <a href="#none">
                <i className="fab fa-pinterest-p"></i>
              </a>
              <a href="#none">
                <i className="fab fa-instagram"></i>
              </a> */}
            </div>
          </div>
        </div>
      </footer>

      <div className="search-popup">
        <div className="search-popup__overlay custom-cursor__overlay search-overlay"></div>
        <div className="search-popup__inner">
          <form action="#" className="search-popup__form">
            <input
              type="text"
              name="search"
              placeholder="Type here to Search...."
            />
            <button type="submit">
              <i className="kipso-icon-magnifying-glass"></i>
            </button>
            <div className="cancel"></div>
          </form>
        </div>
      </div>
    </div>
  );
};
export default Footer;
